// Mock data for Ayurmed Global website

export const companyInfo = {
  name: "Ayurmed Global",
  tagline: "Pioneering AI-Enabled Integrated Ayurvedic Healthcare Solutions",
  description: "Transforming healthcare through the seamless integration of ancient Ayurvedic wisdom with cutting-edge AI technology.",
  email: "info@ayurmedglobal.com",
  phone: "+91-9958096324",
  address: "B-584, Street Number 2, Block B, Sainik Colony, Sector 49, Faridabad, Haryana-121001, India."
};

export const targetAudiences = [
  { id: 1, title: "Hospitals", description: "Modern facilities seeking Ayurvedic integration" },
  { id: 2, title: "Practitioners", description: "Healthcare professionals expanding their practice" },
  { id: 3, title: "Wellness Centers", description: "Holistic centers embracing traditional medicine" }
];

// Updated service sequence as requested
export const services = [
  {
    id: 1,
    title: "Patient Care",
    shortTitle: "Patient Care",
    description: "Comprehensive patient care solutions combining traditional Ayurvedic approaches with modern healthcare standards for holistic healing.",
    icon: "heart",
    accentColor: "accent-pink",
    iconType: "healing",
    features: [
      "Personalized treatment plans",
      "Holistic wellness programs",
      "Patient monitoring systems",
      "Recovery support services"
    ]
  },
  {
    id: 2,
    title: "Integrated Medicine",
    shortTitle: "Integrated Medicine",
    description: "Comprehensive integrated medicine solutions combining traditional Ayurvedic practices with modern healthcare approaches for holistic patient care.",
    icon: "leaf",
    accentColor: "accent-green",
    iconType: "ayurveda",
    features: [
      "Holistic treatment protocols",
      "Combined therapy approaches",
      "Patient-centered care",
      "Evidence-based integration"
    ]
  },
  {
    id: 3,
    title: "AI Powered Education, Training & Research Programs",
    shortTitle: "Training & Research",
    description: "Comprehensive multilingual education courses for doctors, nursing staff, and healthcare providers powered by advanced AI learning systems with research collaboration.",
    icon: "graduation-cap",
    accentColor: "accent-blue",
    iconType: "ai",
    features: [
      "Doctor certification programs",
      "Nursing staff training",
      "Research collaboration",
      "Continuous medical education"
    ]
  },
  {
    id: 4,
    title: "AI Powered Preventive Care - Build Digital Health Profile",
    shortTitle: "AI Preventive Care",
    description: "Revolutionary AI-driven preventive healthcare solutions enabling patients to build comprehensive digital health profiles for personalized wellness management.",
    icon: "home",
    accentColor: "accent-cyan",
    iconType: "ai",
    features: [
      "Digital health profiling",
      "AI health assessments",
      "Preventive care plans",
      "Personalized wellness tracking"
    ]
  },
  {
    id: 5,
    title: "Medicine & Herbal Supply Chain",
    shortTitle: "Supply Chain",
    description: "Reliable supply chain management for authentic Ayurvedic medicines, herbs, and therapeutic materials with quality assurance.",
    icon: "package",
    accentColor: "accent-amber",
    iconType: "ayurveda",
    features: [
      "Authentic herb sourcing",
      "Quality certification",
      "Global distribution network",
      "Inventory management"
    ]
  },
  {
    id: 6,
    title: "RHID™ - AI Hospital Management Software",
    shortTitle: "RHID™ Software",
    description: "Complete AI-powered hospital information and diagnostics system designed specifically for Ayurvedic and integrated medicine facilities.",
    icon: "brain",
    accentColor: "accent-cyan",
    iconType: "ai",
    features: [
      "AI-powered diagnostics",
      "Electronic health records",
      "Multilingual support",
      "Integration with modern systems"
    ]
  },
  {
    id: 7,
    title: "Expert Network & Partnerships",
    shortTitle: "Expert Network",
    description: "Access to a curated network of certified Ayurvedic doctors, Panchakarma specialists, and healthcare consultants worldwide.",
    icon: "users",
    accentColor: "accent-green",
    iconType: "ayurveda",
    features: [
      "Certified practitioners",
      "Global specialist network",
      "Consultation services",
      "Partnership opportunities"
    ]
  },
  {
    id: 8,
    title: "Equipment Procurement & Maintenance",
    shortTitle: "Equipment",
    description: "Herbal and Medicinal Plant Cultivation: End-to-end services form land suitability and soil analysis to digital growth monitoring with  AI enabled herbal crop advisory.",
    icon: "package",
    accentColor: "accent-amber",
    iconType: "ayurveda",
    features: [
      "Agro-climate feasibility study",
      "Certified seed and sapling supply",
      "Cultivation management services",
      "Certification and compliances",
      "Harvesting Drying and Primary processing"
    ]
  },
  {
    id: 9,
    title: "Hospital Interior Design & Vastu",
    shortTitle: "Interior Design",
    description: "Specialized interior design services combining modern aesthetics with traditional Vastu principles for healing environments.",
    icon: "home",
    accentColor: "accent-pink",
    iconType: "healing",
    features: [
      "Vastu-compliant designs",
      "Healing environment creation",
      "Modern aesthetics",
      "Space optimization"
    ]
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Deep Expertise",
    description: "25+ years of combined experience in Ayurveda and healthcare technology",
    icon: "brain",
    iconType: "ai"
  },
  {
    id: 2,
    title: "AI Integration",
    description: "Cutting-edge AI solutions designed specifically for Ayurvedic healthcare",
    icon: "leaf",
    iconType: "ayurveda"
  },
  {
    id: 3,
    title: "Global Reach",
    description: "Successfully operating across multiple countries with localized solutions",
    icon: "globe",
    iconType: "ai"
  },
  {
    id: 4,
    title: "Certified Excellence",
    description: "NABH, ISO, and WHO-GMP certified processes and products",
    icon: "award",
    iconType: "ayurveda"
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Initial Consultation",
    description: "Understanding your vision and requirements",
    icon: "message-circle"
  },
  {
    id: 2,
    title: "Custom Planning",
    description: "Tailored solutions for your facility",
    icon: "file-text"
  },
  {
    id: 3,
    title: "Implementation",
    description: "Seamless integration and setup",
    icon: "settings"
  },
  {
    id: 4,
    title: "Continuous Support",
    description: "Ongoing monitoring and optimization",
    icon: "users"
  }
];
